import { render, staticRenderFns } from "./FormEditor.vue?vue&type=template&id=bf7eac2c"
import script from "./FormEditor.vue?vue&type=script&lang=ts"
export * from "./FormEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports